module.exports = __webpack_public_path__ + "product/icon_pc-0cd68daed71e15de5a8a094246556b14.svg";